import { render, staticRenderFns } from "./wy-table-column.vue?vue&type=template&id=3cf8a4ec&"
import script from "./wy-table-column.vue?vue&type=script&lang=js&"
export * from "./wy-table-column.vue?vue&type=script&lang=js&"
import style0 from "./wy-table-column.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports